import {Box, Button, Checkbox, Stack, Typography} from "@mui/material";

const plural = (count, word) => `${count} ${word}${count === 1 ? "" : "s"}`;

export const PhoneNumbersToolbarNew = ({
  total, duplicateCount, emptyCount, onlyIssues, onOnlyIssuesChange, onRemoveDuplicates, onClear
}) => {
  const invalidCount = duplicateCount + emptyCount;

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{mb: 1}}>
        <Typography sx={{fontWeight: 600, fontSize: 13, color: "#23264D"}}>{plural(total, "phone number")}</Typography>
        <Stack direction="row" gap={1} alignItems="center">
          {invalidCount > 0 && (
            <Stack component="label" direction="row" alignItems="center" gap={0.5} sx={{cursor: "pointer"}}>
              <Checkbox size="small" checked={onlyIssues} onChange={(e) => onOnlyIssuesChange(e.target.checked)}
                        sx={{p: 0.5, color: "#C9CAD8", "&.Mui-checked": {color: "#8491F7"}}}/>
              <Typography sx={{fontSize: 13, color: "#6B6B80"}}>Show only issues</Typography>
            </Stack>
          )}
          {duplicateCount > 0 && (
            <Button size="small" onClick={onRemoveDuplicates} sx={{textTransform: "none", fontWeight: 700, fontSize: 12, color: "#A86A0C", "&:hover": {bgcolor: "rgba(217, 161, 58, 0.1)"}}}>
              Remove duplicates
            </Button>
          )}
          {total > 0 && (
            <Button size="small" onClick={onClear} sx={{textTransform: "none", fontWeight: 700, fontSize: 12, color: "#DC2626", "&:hover": {bgcolor: "rgba(220, 38, 38, 0.08)"}}}>
              Clear all
            </Button>
          )}
        </Stack>
      </Stack>

      {invalidCount > 0 && (
        <Box sx={{p: 1.25, borderRadius: "10px", bgcolor: "rgba(217, 161, 58, 0.1)", mb: 1}}>
          <Typography sx={{fontSize: 12, color: "#9A6B1F"}}>
            {duplicateCount > 0 && `${plural(duplicateCount, "duplicate number")}. `}
            {emptyCount > 0 && `${plural(emptyCount, "empty row")}. `}
            Fix or remove them before saving the campaign.
          </Typography>
        </Box>
      )}
    </>
  )
}
